<template>
  <div id="ResetPasswordForm">
    <div class="modal-card fixed-width dtac-font">
      <!-- Modal Title -->
      <header class="modal-card-head">
        <p class="modal-card-title">RESET PASSWORD</p>
      </header>
      <!-- Modal Description + Input -->
      <section class="modal-card-body">
        <div class="media">
          <div class="media-content">
            <!-- Modal Description -->
            <p class="subtitle is-6">
              Enter new password for <b>{{ profile.username }}</b>
            </p>
            <!-- Modal Input Field -->
            <b-field>
              <b-input
                required
                type="password"
                password-reveal
                v-model="password"
                placeholder="New Password"
              />
            </b-field>
          </div>
        </div>
      </section>
      <!-- Modal Footer -->
      <footer class="modal-card-foot" style="justify-content: flex-end;">
        <!-- Button: Save -->
        <button
          class="button is-primary"
          :disabled="disableResetPassword"
          @click.prevent="performChangePassword()"
        >
          Confirm
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import UserApi from "@/services/UserApi";
import AlertManager from "@/utils/AlertManager";

export default {
  name: "ResetPasswordForm",
  props: ["profile"],
  data() {
    return {
      password: null
    };
  },
  computed: {
    disableResetPassword: function() {
      if (this.password && this.password !== "") {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    performChangePassword: async function() {
      if (!this.disableResetPassword) {
        const params = {
          _id: this.profile._id,
          new_password: this.password
        };
        const loadingComponent = this.$buefy.loading.open({
          container: null
        });
        const response = await UserApi.requestResetPassword(params);
        loadingComponent.close();

        if (response.status) {
          this.$emit("close");
          AlertManager.showSuccessSnackbar(response.message);
        } else {
          AlertManager.showErrorSnackbar(response.message);
        }
      }
    }
  }
};
</script>

<style scoped>
.fixed-width {
  max-width: 480px;
  padding: 0 20px;
}
</style>
